<template>

    <div>

        <!--{{  options }}

        <hr>
        <hr>
        {{  preselected }}-->
        <multiselect
            v-model="value"
            :options="multiselectOptions"
            :close-on-select="false"
            :multiple="true"
            :placeholder="'Add some tags'"
            :taggable="true"
            track-by="name"
            label="name"
            @tag="addTag"
        >

        </multiselect>

        <input type="hidden" name="tags" :value="stringifiedValue" />

    </div>

</template>

<script>
  import Multiselect from 'vue-multiselect';

  export default {

    components: { Multiselect },

    data() {

      return {
        value: this.preselected,
        multiselectOptions: this.options,
      };

    },

    computed: {
      stringifiedValue() {

        return this.value.map(function( tag ) {
          return tag.name;
        });

      },
    },

    props: {
      options: {
       required: true
      },
      preselected: {
        required: true
      },
    },

    methods: {
      addTag (newTag) {
        const tag = { name: newTag };
        this.multiselectOptions.push(tag);
        this.value.push(tag);
      }
    }

  };

</script>

<!-- Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

    .multiselect__placeholder {

        padding: 0;
        margin: 8px 10px;

    }

    .multiselect__tag {

        margin: 8px 0 0 8px;
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 1.6;
        padding: 1px 21px 1px 5px;
    }

    .multiselect__tags {

        min-height: 40px;
        padding: 0;
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 1.6;
        color: #495057;
        background-color: #fff;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    }

    .multiselect__option {

        padding: 9px 10px;
        min-height: 10px;

    }

    .multiselect__option,
    .multiselect__input
    {

        font-size: 0.9rem;
        font-weight: 400;
        line-height: 1.6;

    }

    .multiselect__input {

        color: #495057;
        padding: 8px 10px;

    }

</style>
